import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../stylesheets/components/partner-logos.module.css";
import { PartnerLogoSize, TranslatedPartnerLogo } from "../types/index.js";
import PartnerLogo from "./PartnerLogo.js";

interface Props {
  partnerLogos: TranslatedPartnerLogo[];
  logoSize: PartnerLogoSize;
  compactOrder?: "first" | "last";
}

const PartnerLogos: FunctionComponent<Props> = ({
  partnerLogos,
  logoSize,
  compactOrder: compactType,
}) => {
  return (
    <div
      className={ClassNames({
        [styles["PartnerLogos--compact-first"]]: compactType === "first",
        [styles["PartnerLogos--compact-last"]]: compactType === "last",
      })}
    >
      <div className={styles.PartnerLogos__Inner}>
        {partnerLogos.map((partnerLogo) => (
          <PartnerLogo
            key={partnerLogo.id}
            partnerLogo={partnerLogo}
            size={logoSize}
          />
        ))}
      </div>
    </div>
  );
};

export default PartnerLogos;
